/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventPartyInfo,
    JsonEventPartyInfoFromJSON,
    JsonEventPartyInfoFromJSONTyped,
    JsonEventPartyInfoToJSON,
} from './JsonEventPartyInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEventPartyInfo
 */
export interface ApiResultOfJsonEventPartyInfo {
    /**
     * 
     * @type {JsonEventPartyInfo}
     * @memberof ApiResultOfJsonEventPartyInfo
     */
    data?: JsonEventPartyInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEventPartyInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventPartyInfo
     */
    result?: ApiResultOfJsonEventPartyInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventPartyInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventPartyInfoFromJSON(json: any): ApiResultOfJsonEventPartyInfo {
    return ApiResultOfJsonEventPartyInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventPartyInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEventPartyInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventPartyInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventPartyInfoToJSON(value?: ApiResultOfJsonEventPartyInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventPartyInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

